var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 3.33333,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3913 6.18515C14.5142 6.35705 14.5832 6.59018 14.5832 6.83326C14.5832 7.07634 14.5142 7.30946 14.3913 7.48137L11.7699 11.1482L9.14852 14.815C9.02562 14.9869 8.85896 15.0834 8.68519 15.0834C8.51141 15.0834 8.34475 14.9869 8.22186 14.815L5.60047 11.1482C5.48109 10.9753 5.41504 10.7437 5.41653 10.5034C5.41802 10.263 5.48694 10.0331 5.60845 9.86314C5.72996 9.69317 5.89433 9.59676 6.06616 9.59468C6.23799 9.59259 6.40353 9.68499 6.52713 9.85197L8.68519 12.8707L13.4646 6.18515C13.5875 6.01329 13.7542 5.91675 13.928 5.91675C14.1017 5.91675 14.2684 6.01329 14.3913 6.18515Z",
    fill: "#5BB466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.ffa2321706fc10ab7e48c403508f1719.svg";
export { ForwardRef as ReactComponent };